/**
 * Converts a half-hour slot number to a "HH:MM" label.
 * Slot 0 = 00:00, slot 1 = 00:30, slot 16 = 08:00, slot 36 = 18:00.
 */
export function numberToHourMinuteLabel(value: number): string {
  const hours = Math.floor(value / 2);
  const minutes = (value % 2) * 30;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

/**
 * Converts a Date's hours and minutes to a slider value (half-hour slots).
 */
export function timeToSliderValue(date: Date): number {
  return date.getHours() * 2 + Math.floor(date.getMinutes() / 30);
}

/**
 * Creates a string key from a time range tuple for grouping.
 */
export function getTimeRangeKey(timeRange: [number, number]): string {
  return `${timeRange[0]}-${timeRange[1]}`;
}
